<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.activities_index,
                    },
                    {
                        name: subject.name,
                        href: meta.links.subject_tag_scores_index,
                    },
                    {
                        name: block.name,
                        href: meta.links.content_block_scores_index,
                    },
                    {
                        name: tag.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="divide-y divide-gray-200 w-full">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs md:w-40 px-6 py-1 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.activity_mode') }}
                                </th>
                                <th
                                    class="max-w-xs px-2 py-1 bg-gray-50 text-xs text-left leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.difficulty') }}
                                </th>
                                <th
                                    class="max-w-xs px-2 py-1 bg-gray-50 text-xs text-left leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.speed') }}
                                </th>
                                <th
                                    class="max-w-xs px-2 py-1 bg-gray-50 text-xs text-left leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.date') }}
                                </th>
                                <th
                                    class="max-w-xs px-2 py-1 bg-gray-50 text-xs text-left leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.precision') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(attempt, index) in attempts.data"
                                :key="attempt.id"
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-1 whitespace-nowrap text-left text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ attempt.mode }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-6 py-1 whitespace-nowrap text-left text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ attempt.difficulty }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-6 py-1 whitespace-nowrap text-left text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ attempt.duration }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-6 py-1 whitespace-nowrap text-left text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ attempt.date }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-6 py-1 whitespace-nowrap text-left text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ attempt.score }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="attempts" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';

export default {
    components: {
        InertiaPagination,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['block', 'tag', 'subject', 'attempts', 'meta'],
};
</script>
